import React, { useEffect } from 'react';

export default function Welcome() {
  useEffect(() => {
    const handleMouseMove = (e) => {
      const orb = document.querySelector('.orb-container');
      if (orb) {
        const x = (window.innerWidth - e.pageX * 2) / 50;
        const y = (window.innerHeight - e.pageY * 2) / 50;
        orb.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`;
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="welcome-page">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Anton&display=swap');

        .welcome-page {
          --meme-yellow: #F5C544;
          --meme-orange: #E69D36;
          --meme-shadow: #B67824;
          --stroke-color: #000000;
          --text-white: #FFFFFF;
          background-color: #000;
          color: var(--text-white);
          font-family: 'Anton', sans-serif;
          height: 100vh;
          width: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 100;
        }

        .orb-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 120vmin;
          height: 120vmin;
          z-index: 1;
          pointer-events: none;
          filter: blur(20px) contrast(1.2);
        }

        .orb {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: radial-gradient(circle at 30% 30%, 
            #FFEB3B 0%, 
            var(--meme-yellow) 40%, 
            var(--meme-orange) 70%, 
            var(--meme-shadow) 100%);
          box-shadow: 0 0 100px rgba(245, 197, 68, 0.5);
          animation: breathe 4s ease-in-out infinite alternate;
        }

        .noise-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;
          opacity: 0.15;
          pointer-events: none;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
        }

        .content-layer {
          position: relative;
          z-index: 10;
          text-align: center;
          width: 100%;
          max-width: 1400px;
          padding: 2rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1vh;
          mix-blend-mode: normal;
        }

        .intro-text {
          font-size: clamp(2rem, 4vw, 3.5rem);
          color: var(--text-white);
          -webkit-text-stroke: 1.5px var(--stroke-color);
          paint-order: stroke fill;
          text-shadow: 2px 2px 0 #000;
          letter-spacing: 0.02em;
          line-height: 1.1;
          transform: rotate(-1deg);
        }

        .hero-text {
          font-size: clamp(3.5rem, 9vw, 10rem);
          text-transform: uppercase;
          color: var(--text-white);
          -webkit-text-stroke: clamp(2px, 0.4vw, 6px) var(--stroke-color);
          paint-order: stroke fill;
          text-shadow: 4px 4px 0 #000;
          line-height: 0.9;
          letter-spacing: -0.02em;
          margin-top: 1rem;
          max-width: 90%;
        }

        .cta-container {
          margin-top: 4rem;
          display: flex;
          gap: 2rem;
          justify-content: center;
        }

        .meme-btn {
          background: transparent;
          border: none;
          font-family: 'Anton', sans-serif;
          font-size: clamp(1.5rem, 3vw, 2.5rem);
          color: var(--text-white);
          -webkit-text-stroke: 2px var(--stroke-color);
          paint-order: stroke fill;
          text-shadow: 2px 2px 0 #000;
          cursor: pointer;
          text-transform: uppercase;
          position: relative;
          transition: transform 0.1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          text-decoration: none;
        }

        .meme-btn::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 100%;
          height: 4px;
          background: white;
          border: 2px solid black;
          box-shadow: 2px 2px 0 black;
        }

        .meme-btn:hover {
          transform: scale(1.05) rotate(1deg);
        }

        .meme-btn:active {
          transform: scale(0.95);
        }

        .tech-badge {
          position: absolute;
          bottom: 5vh;
          right: 5vw;
          width: 120px;
          height: 120px;
          background: #fff;
          border: 3px solid black;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          text-align: center;
          color: black;
          -webkit-text-stroke: 0;
          text-shadow: none;
          transform: rotate(15deg);
          box-shadow: 5px 5px 0 rgba(0,0,0,1);
          animation: float 3s ease-in-out infinite;
          z-index: 20;
          line-height: 1;
          padding: 10px;
        }

        @keyframes breathe {
          0% { transform: scale(1); }
          100% { transform: scale(1.05); }
        }

        @keyframes float {
          0%, 100% { transform: rotate(15deg) translateY(0); }
          50% { transform: rotate(15deg) translateY(-10px); }
        }

        .hero-text:hover {
          animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
          cursor: default;
        }

        @keyframes shake {
          10%, 90% { transform: translate3d(-1px, 0, 0); }
          20%, 80% { transform: translate3d(2px, 0, 0); }
          30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
          40%, 60% { transform: translate3d(4px, 0, 0); }
        }
      `}</style>

      <div className="orb-container">
        <div className="orb"></div>
      </div>

      <div className="noise-overlay"></div>

      <main className="content-layer">
        <p className="intro-text">
          "wait, you actually want to fix the world?"
        </p>

        <h1 className="hero-text">
          LETS MAKE <br />
          THE PLACE YOU LIVE<br />
          THE PLACE YOU LOVE TO BE
        </h1>

        <div className="cta-container">
          <a href="#" className="meme-btn">JOIN US</a>
        </div>
      </main>

      <div className="tech-badge">
        FUTURE<br />OPTIMISM<br />ONLY
      </div>
    </div>
  );
}